import { DatepickerFooter } from './DatepickerFooter';
import { useDatepickerStore } from '@/stores/DatepickerStore/DatepickerStore';
import { DatepickerSingleFooterProps } from './DatepickerFooter.consts';

export const DatepickerSingleFooter: React.FC<DatepickerSingleFooterProps> = ({
  onSingleDateSelect,
}: DatepickerSingleFooterProps) => {
  const { clearDate, setIsOpen, getSelectedDate } = useDatepickerStore();

  const closeDatepicker = () => {
    clearDate();
    setIsOpen(false);
  };

  const onSelect = () => {
    if (!onSingleDateSelect) {
      throw new Error('onSingleDateSelect is not provided for single datepicker');
    }
    onSingleDateSelect(getSelectedDate());
    closeDatepicker();
  };

  return <DatepickerFooter onClose={closeDatepicker} onSelect={onSelect} />;
};
